import { Store } from 'redux';
import { NotFoundError } from '@cian/peperrors/shared';

import { getReviewsRealtorPage, renderReactApp } from './internal';
import { IAppState, IContext } from '../../../shared/store';

export function renderApp(store: Store<IAppState>, context: IContext) {
  const rootElement = document.getElementById('realtor-reviews-frontend');

  if (!rootElement) {
    throw new NotFoundError({
      message: 'Unable to find element #realtor-reviews-frontend',
      domain: 'services#renderApp',
    });
  }

  const reviewsRealtorPage = getReviewsRealtorPage(context);

  /* Снимок SSR-разметки до гидрации — из него корневой boundary восстановит контент,
     если ошибка дойдёт до самого верха. После hydrateRoot DOM уже принадлежит React. */
  const ssrMarkup = rootElement.innerHTML;

  renderReactApp({
    app: reviewsRealtorPage,
    store,
    context,
    rootElement,
    ssrMarkup,
  });
}
